// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".order-list-item .cod-blue{color:#187feb!important}.order-mode__width{width:57px}.order-list-item .text-bubble{margin-left:12px;margin-top:0;padding-bottom:12px;width:100%}.order-list-item .order-timeout-alert{height:40px}.text-truncate{max-width:51px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
